/**
 * board-version-diff — 보드 model(things-scene 컴포넌트 트리) diff 순수 로직 단위 검증.
 */
import { diffBoardModels, flattenBoardComponents } from './board-version-diff'

describe('board-version-diff (pure)', () => {
  describe('flattenBoardComponents', () => {
    it('flattens nested components recursively', () => {
      const model = {
        components: [
          { refid: 1, type: 'rect' },
          { refid: 2, type: 'group', components: [{ refid: 3, type: 'text' }] }
        ]
      }
      const flat = flattenBoardComponents(model)
      expect(flat.map(f => f.refid)).toEqual([1, 2, 3])
    })

    it('parses a JSON string model', () => {
      const model = JSON.stringify({ components: [{ refid: 1, type: 'rect' }] })
      expect(flattenBoardComponents(model).map(f => f.refid)).toEqual([1])
    })

    it('returns [] for null/invalid model', () => {
      expect(flattenBoardComponents(null)).toEqual([])
      expect(flattenBoardComponents('not-json')).toEqual([])
      expect(flattenBoardComponents({})).toEqual([])
    })
  })

  describe('diffBoardModels', () => {
    it('detects added, removed, and modified components by refid', () => {
      const base = {
        components: [
          { refid: 1, type: 'rect', left: 0 },
          { refid: 2, type: 'text', text: 'hello' }
        ]
      }
      const target = {
        components: [
          { refid: 1, type: 'rect', left: 50 }, // modified (left)
          { refid: 3, type: 'circle' } // added
          // refid 2 removed
        ]
      }
      const diffs = diffBoardModels(base, target)
      const byType = (t: string) => diffs.filter(d => d.changeType === t).map(d => d.refid).sort()

      expect(byType('added')).toEqual([3])
      expect(byType('removed')).toEqual([2])
      expect(byType('modified')).toEqual([1])

      const modified = diffs.find(d => d.refid === 1)
      expect(modified?.changedProps).toContain('left')
    })

    it('reports no diffs for identical models', () => {
      const model = { components: [{ refid: 1, type: 'rect', left: 10 }] }
      expect(diffBoardModels(model, JSON.parse(JSON.stringify(model)))).toEqual([])
    })

    it('ignores children array when diffing a container component props', () => {
      const base = { components: [{ refid: 1, type: 'group', components: [{ refid: 2, type: 'text' }] }] }
      // 자식만 바뀌고 컨테이너 자체 속성은 동일 → 컨테이너는 modified 아님, 자식만 removed
      const target = { components: [{ refid: 1, type: 'group', components: [] }] }
      const diffs = diffBoardModels(base, target)
      expect(diffs.find(d => d.refid === 1)).toBeUndefined()
      expect(diffs.find(d => d.refid === 2)?.changeType).toBe('removed')
    })

    it('falls back to positional key when refid is missing', () => {
      const base = { components: [{ type: 'rect', left: 0 }] }
      const target = { components: [{ type: 'rect', left: 99 }] }
      const diffs = diffBoardModels(base, target)
      expect(diffs).toHaveLength(1)
      expect(diffs[0].changeType).toBe('modified')
      expect(diffs[0].changedProps).toContain('left')
    })
  })
})
